import PAIRED_EVENT_STRIPES, { PAIRED_EVENT_CLASS } from '../../../utils/constants/pairedEventStyle'

const calendarPageStyles = {
  '@global': {
    [`.fc .${PAIRED_EVENT_CLASS}`]: {
      backgroundImage: PAIRED_EVENT_STRIPES,
      cursor: 'pointer',
    },
  },
  card: {
    height: 'fit-content',
    marginTop: 10,
  },
  cardContent: {
    '&&': {
      paddingBottom: 33,
    },
  },
  drawerPaper: {
    width: '31%',
    minWidth: 664,
    maxWidth: '100%',
    overflow: 'hidden',
  },
  drawerContainer: { height: '100%', overflow: 'auto' },
  filtersContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    marginBottom: 15,
    marginTop: 15,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
}

export default calendarPageStyles
